import React, { useState } from 'react';
import { api, apiError } from '../lib/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [debugToken, setDebugToken] = useState('');

  const [token, setToken] = useState('');
  const [newPw, setNewPw] = useState('');

  const submit = async (e) => {
    e.preventDefault(); setErr(''); setMsg(''); setBusy(true);
    try {
      const { data } = await api.post('/auth/forgot-password', { email });
      setMsg(data.message || 'Check your email');
      if (data.debug_token) { setDebugToken(data.debug_token); setToken(data.debug_token); }
    } catch (e) { setErr(apiError(e)); } finally { setBusy(false); }
  };
  const reset = async (e) => {
    e.preventDefault(); setErr(''); setMsg(''); setBusy(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: newPw });
      setMsg('Password reset successful — you can now log in.');
    } catch (e) { setErr(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="container my-5" style={{maxWidth:520}} data-testid="forgot-page">
      <h1>Forgot password</h1>
      <div className="ap-card mt-3">
        {msg && <div className="alert alert-success" data-testid="forgot-msg">{msg}</div>}
        {err && <div className="alert alert-danger" data-testid="forgot-err">{err}</div>}
        <form onSubmit={submit} className="mb-3" data-testid="forgot-form">
          <label className="form-label">Enter your email</label>
          <div className="d-flex gap-2">
            <input className="form-control" type="email" value={email} onChange={e=>setEmail(e.target.value)} required data-testid="forgot-email"/>
            <button className="btn-ap" disabled={busy} data-testid="forgot-submit">Send reset</button>
          </div>
        </form>
        <hr />
        <p className="small text-muted-2 mb-2">Have a reset token? Enter it here (demo shows the token above).</p>
        {debugToken && <div className="alert alert-warning small">Debug token (dev only): <code>{debugToken}</code></div>}
        <form onSubmit={reset} data-testid="reset-form">
          <label className="form-label">Reset token</label>
          <input className="form-control mb-2" value={token} onChange={e=>setToken(e.target.value)} required data-testid="reset-token"/>
          <label className="form-label">New password</label>
          <input className="form-control mb-2" type="password" value={newPw} onChange={e=>setNewPw(e.target.value)} required data-testid="reset-password"/>
          <button className="btn-ap-outline" disabled={busy} data-testid="reset-submit">Reset password</button>
        </form>
      </div>
    </div>
  );
}
